/**
 * Composed Create, the wizard's one automatic route after concept analysis:
 * plan → the plan's steps → spec synthesis → the acknowledgement → build. The
 * steps a plan runs (`composedPlannedStepsV1`) and the template they name
 * (`composedStepsTemplateIdV1`) are the server's, from @djgg/creations; this
 * file only says how each step is shown. The wizard runs them
 * (NewGameWizard) and never asks the creator to confirm between them.
 */
import type { ComposePlanV1 } from '@djgg/creations';
import { composedFitCandidatesV1 } from '@djgg/creations';

/** The plan's base template by its catalog title (null for a new game). */
export function composedPlanTemplateTitleV1(plan: ComposePlanV1 | null): string | null {
  if (!plan?.templateId) return null;
  return composedFitCandidatesV1().find(candidate => candidate.templateId === plan.templateId)?.label ?? null;
}
